
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.953 3.29h9.602L8.78.86l.461-.43 3.211 3.132v.766H.953V3.29zm11.5 4.28H2.852l1.773 2.438-.46.43L.952 7.304V6.53h11.5v1.04z","fill":"currentColor"}})])
          )
        }
      }
    